import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { CmsData, fetchCms } from '../lib/api';

// 多语言回退：取当前语言，缺失回退 zh
export function pickLang(
  obj: Record<string, string> | undefined,
  lang: string,
  fallback = ''
): string {
  if (!obj) return fallback;
  return obj[lang] || obj['zh'] || fallback;
}

interface CmsContextType {
  cms: CmsData | null;
  announcements: CmsData['announcements'];
  team: CmsData['team'];
  others: CmsData['others'];
  refresh: () => void;
}

const CmsContext = createContext<CmsContextType | undefined>(undefined);

export const CmsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [cms, setCms] = useState<CmsData | null>(null);

  const refresh = () => {
    fetchCms()
      .then(setCms)
      .catch(() => {
        // 后端不可用：保持 null，各组件回退到内置硬编码内容，站点独立可用
      });
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <CmsContext.Provider
      value={{
        cms,
        announcements: cms?.announcements ?? [],
        team: cms?.team ?? [],
        others: cms?.others ?? [],
        refresh,
      }}
    >
      {children}
    </CmsContext.Provider>
  );
};

export const useCms = () => {
  const context = useContext(CmsContext);
  if (!context) {
    throw new Error('useCms must be used within CmsProvider');
  }
  return context;
};